export interface IMatiereEcole {
  id?: string;
  nom?: string;
  color?: string;
  ecoleId?: string;
  avecSousMatieres?: boolean;
  cycleMatiereId?: string;
}

export const defaultEcoleMatiere: Readonly<IMatiereEcole> = {};
export interface ICoefficient {
  id?: string;
  matiereId: string;
  classeId: string;
  coefficient: number;
}

export interface IMatiereCoeff {
  matiere: IMatiereEcole;
  coeff: ICoefficient;
}
export const defaultEcoleMatiereCoeff: ReadonlyArray<IMatiereCoeff> = [{ coeff: null, matiere: null }];
